// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","wrapper":"accordian_wrapper__0MaOW"};